<script>
	import { Button, Col, Row } from "sveltestrap";
	import { form, field } from "svelte-forms";
	import { required, min, max, email } from "svelte-forms/validators";
	import Loader from "../../components/Loader/Loader.svelte";
	import PageHeader from "../../components/PageHeader/PageHeader.svelte";
	import ErrorMessageHandler from "../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import client from "../../services/client";
	import { errorMessage, editEvData, masterData } from "../../store/store";
	import { navigate } from "svelte-routing";
	import { extractErrorMessage } from "../../utils/misc";
	import CustomInput from "../../components/CustomInput/CustomInput.svelte";
	import CustomSelect from "../../components/CustomSelect/CustomSelect.svelte";

	const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop),
	});

	const userEmail = field(
		"userEmail",
		`${params.id ? $editEvData?.email : ""}`,
		[required(), email()]
	);
	const ev_company_id = field(
		"ev_company_id",
		params.id ? $editEvData?.evCompanyId : "",
		[]
	);
	const car_plate_number = field(
		"car_plate_number",
		`${params.id ? $editEvData?.carPlateNumber : ""}`,
		[required()]
	);
	const password = field(
		"password",
		`${params.id ? $editEvData?.password : ""}`,
		[required(), min(8), max(25)]
	);

	const myForm = form(userEmail, ev_company_id, car_plate_number, password);

	let duplicateUserEmail;
	let duplicatePlateNo;
	let load = false;

	async function handleSubmit() {
		load = true;
		try {
			const res = await client("/v1/evChargingAccount", {
				method: params.id ? "PUT" : "POST",
				version: "evCharging",
				data: {
					email: $userEmail.value,
					providerId: +$ev_company_id.value,
					carPlateNumber: $car_plate_number.value,
					password: params.id ? undefined : $password.value,
					id: +params.id,
				},
			});

			if (res.data.code === 200) {
				navigate("/account/ev-account-management");
			} else {
				load = false;
				extractErrorMessage(res.data.message);
			}
		} catch (error) {
			load = false;
			extractErrorMessage(error);
		}
	}
</script>

<Row>
	<Col>
		<div>
			<ErrorMessageHandler message={$errorMessage} />
			<PageHeader
				title={` ${params.id ? "Edit" : "Create"} EV Account`}
			/>
			<Col>
				<Row>
					<Col>
						<label for="car_plate_number" class="d-block mb-2">
							<span>
								<b
									>Car plate number<span
										style="color: #D7313C;">*</span
									></b
								>
							</span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={5}>
						<CustomInput
							type="text"
							bind:value={$car_plate_number.value}
							placeholder="e.g. SLP1299Y"
							error={$myForm.hasError(
								"car_plate_number.required"
							) || duplicatePlateNo}
							errorText={$myForm.hasError(
								"car_plate_number.required"
							)
								? "Car plate number is required"
								: duplicatePlateNo
								? "This car plate number is already added"
								: ""}
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="userEmail" class="d-block mt-3 mb-2">
							<span>
								<b
									>Email<span style="color: #D7313C;">*</span
									></b
								>
							</span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={5}>
						<CustomInput
							type="email"
							bind:value={$userEmail.value}
							error={$myForm.hasError("userEmail.required") ||
								duplicateUserEmail}
							errorText={$myForm.hasError("userEmail.required")
								? "Email is required"
								: duplicateUserEmail
								? "This email is already added"
								: duplicatePlateNo
								? "This email is already added"
								: ""}
							placeholder="e.g. user@email.com"
						/>
					</Col>
				</Row>
			</Col>

			<Col>
				<Row>
					<Col>
						<label for="password" class="d-block mt-3 mb-2">
							<span>
								<b
									>Password<span style="color: #D7313C;"
										>*</span
									></b
								>
							</span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={5}>
						<CustomInput
							type="password"
							bind:value={$password.value}
							disabled={params.id}
							error={$myForm.hasError("password.required") ||
								$myForm.hasError("password.min") ||
								$myForm.hasError("password.max")}
							errorText={$myForm.hasError("password.required")
								? "Password is required"
								: $myForm.hasError("password.min")
								? "Password Must be a minimum of 8 characters"
								: $myForm.hasError("password.max")
								? "Password Must be a maximum of 25 characters"
								: ""}
						/>
					</Col>
				</Row>
			</Col>

			<Col>
				<Row>
					<Col>
						<label for="EV_operators" class="d-block mt-3 mb-2">
							<span><b>EV charging company</b></span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={5}>
						<CustomSelect
							type="text"
							bind:value={$ev_company_id.value}
							options={$masterData.cpoProviders}
							error={$myForm.hasError("ev_company_id.required")}
							errorText="EV charging company is required"
							defaultOption="Select EV Charging Point operator"
						/>
					</Col>
				</Row>
			</Col>

			<Col class="d-flex justify-content-end">
				<Row>
					<Col>
						<Button class="themeButton" on:click={myForm.reset}
							>RESET</Button
						>
						<!-- svelte-ignore a11y-no-noninteractive-tabindex -->
						<span
							class="d-inline-block"
							tabindex="0"
							data-bs-toggle={!$myForm.valid ? "tooltip" : ""}
							title={!$myForm.valid
								? "Fill all required field"
								: ""}
						>
							<Button
								class="themeButton primary"
								disabled={!$myForm.valid}
								on:click={() => handleSubmit()}
								on:click={myForm.validate}
							>
								{#if load}
									<Loader />
								{:else}
									{params.id ? "UPDATE" : "CREATE"}
								{/if}
							</Button>
						</span>
					</Col>
				</Row>
			</Col>
		</div>
	</Col>
</Row>
